import axios from "axios";
import clientUtil from './clientUtil';
import needSessionRequest from "./needSession";
import { getUrlParam } from './util';

const baseURL = '';
var instance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    'YX-source': "h5",
    'YX-Timestamp': +new Date(),
    'YX-VersionName': '8.0.2',
    'YX-Version': '802',
    'YX-tokenType': 1,
  },
  responseType: "json",
  timeout: 30000
})

instance.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('token');
    const username = sessionStorage.getItem('username');
    const noPassword = sessionStorage.getItem('noPassword');
    if (token) {
      config.headers['token'] = token
    }
    if (username) {
      config.headers['username'] = username
    }
    noPassword && (config.headers['YX-NOPASSWORD'] = noPassword);
    needSessionRequest.includes(config.url) && (config.headers['YX-SESSION'] = getUrlParam("YX-SESSION"));
    console.log('请求头', config);
    return config
  },
  error => {
    return Promise.reject(error.toString())
  }
)

instance.interceptors.response.use(
  res => {
    const { code } = res.data
    if (code === 1311 || code === 1312 || code === 1321) {
      clientUtil.gotoLogin();
      return Promise.reject(new Error('跳转登录'))
    }
    // if (code !== 0) {
    //   return Promise.reject(new Error(res.message || res.desc || res.msg || 'Error'))
    // }
    return res
  },
  error => {
    return Promise.reject(error)
  }
)

export function post(uri, params, cb) {
  if (typeof params == "function") {
    cb = params;
    params = {};
  }
  params = params || {};
  return instance.post(uri, params || {}).then(res => {
    if (cb) {
      cb(res.data || {});
      return;
    }
    return new Promise(resolve => {
      resolve(res.data || {});
    });
  })
}
